// extracted by mini-css-extract-plugin
module.exports = {"root":"history-card_root__W9qRG","link":"history-card_link__WYmpU","subtitle":"history-card_subtitle__tIAsD","platformIcon":"history-card_platformIcon__MZAnp"};